// calibrationLogBookForm/calibrationLogBookFormState.js
// UI state bucket for the standalone calibration log book form.

export const calibrationLogBookFormInitialState = {
  rev: 0,
  calibrationLogUI: {
    isModalOpen: false,
    currentLogId: null,
    isAddMode: false,
    modalHeaderString: "",
    isDeleteConfirmOpen: false,
    logToDelete: null,
  },
};
